/**
 * The one mask over a number a person reads only the end of.
 */
/**
 * A card's or a bank account's last four digits behind four bullets:
 * `maskedLastFour("4242")` is "•••• 4242". app-api sends the digits bare and
 * leaves the mask to the surface, so a payout account in the console and a
 * card in a member's wallet read the same way.
 */
export function maskedLastFour(lastFour) {
    return `•••• ${lastFour}`;
}
